var _defs, _g, _g2, _path, _path2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_8",
    "data-name": "Group 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 131,
    height: 184,
    viewBox: "0 0 131 184",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-1",
    d: "M0,0V11.051H11.1V0H0Z",
    transform: "translate(0 0.01)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "notmapped",
    transform: "translate(12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke-5",
    d: "M6.4,3.2A3.2,3.2,0,1,1,3.2,0,3.2,3.2,0,0,1,6.4,3.2Z",
    transform: "translate(44.611 22.556)",
    fill: "none",
    stroke: "#7f97a7",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-41-Copy",
    transform: "translate(65 37)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-37",
    d: "M2.545,9.932A1.273,1.273,0,0,1,0,9.932V1.272a1.273,1.273,0,0,1,2.545,0Z",
    transform: "translate(4.411 0.013)",
    fill: "#314857"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-39",
    d: "M1.263,2.543A1.272,1.272,0,1,1,1.282,0L9.948.067a1.272,1.272,0,1,1-.02,2.543Z",
    transform: "translate(0.078 4.309)",
    fill: "#314857"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-41-Copy-2",
    transform: "translate(1 44)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-37-2",
    "data-name": "Fill-37",
    d: "M1,4.432A.537.537,0,0,1,.5,5,.537.537,0,0,1,0,4.432V.568A.537.537,0,0,1,.5,0,.537.537,0,0,1,1,.568Z",
    transform: "translate(2)",
    fill: "#314857"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-39-2",
    "data-name": "Fill-39",
    d: "M.563.974A.53.53,0,0,1,0,.483.534.534,0,0,1,.572,0L4.437.026A.53.53,0,0,1,5,.517.533.533,0,0,1,4.428,1Z",
    transform: "translate(0 2)",
    fill: "#314857"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-48",
    d: "M10.079,11.723,6.237,9.75,2.432,11.8l.69-4.261L0,4.55l4.269-.661L6.144,0,8.092,3.853l4.281.581L9.309,7.475Z",
    transform: "translate(90 51)",
    fill: "#5d7483"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-50",
    d: "M5.147,5.986,3.185,4.979,1.242,6.023l.352-2.176L0,2.324l2.18-.338L3.138,0l1,1.967,2.186.3L4.754,3.817Z",
    transform: "translate(93 15)",
    fill: "#5d7483"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-50-Copy",
    d: "M4.333,5.04,2.681,4.191,1.046,5.07l.3-1.832L0,1.956l1.836-.284L2.642,0,3.48,1.656l1.84.249L4,3.214Z",
    transform: "translate(27)",
    fill: "#5d7483"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-52",
    d: "M8.573,9.97,5.3,8.293,2.068,10.032l.587-3.624L0,3.87l3.631-.563L5.226,0,6.883,3.277l3.641.493L7.917,6.358Z",
    transform: "translate(20 45)",
    fill: "#5d7483"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-58",
    transform: "translate(47 54)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-56_Clipped",
    "data-name": "Fill-56 Clipped"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-1-3",
    "data-name": "path-1",
    d: "M0,0V11.051H11.1V0H0Z",
    transform: "translate(0 0.01)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Fill-56_Clipped-2",
    "data-name": "Fill-56 Clipped",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-56",
    d: "M11.1,3.209l-1.156,6.83L3.083,11.051,0,4.848,4.953,0Z",
    transform: "translate(0 0.01)",
    fill: "#d2dde4"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Fill-59",
    d: "M3.109,7.443,0,5.381.232,1.659,3.575,0,6.684,2.062,6.452,5.784Z",
    transform: "translate(3.087 17.291)",
    fill: "#d2dde4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-59-2",
    "data-name": "Fill-59",
    d: "M3.109,7.443,0,5.381.232,1.659,3.575,0,6.684,2.062,6.452,5.784Z",
    transform: "translate(9 62)",
    fill: "#e9eef2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(0 152)",
    fill: "#edeff5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2-Copy",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(69 9)",
    fill: "#d2dde4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-61",
    d: "M2.4,5.745,0,4.153.18,1.281,2.759,0l2.4,1.592L4.98,4.464Z",
    transform: "translate(108.931 39.816)",
    fill: "#e9eef2"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "box_1_",
    "data-name": "box (1)",
    transform: "translate(0 60)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M98,81,49,108,0,81V27L49,0,98,27Z",
    transform: "translate(17 16)",
    fill: "#d2dde4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M0,27H0L49,54,98,27h0L49,0Z",
    transform: "translate(17 16)",
    fill: "#7f97a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    "data-name": "Path",
    d: "M0,.016V53.333L48.971,80,49,79.985V26.667L.029,0Z",
    transform: "translate(15 44)",
    fill: "#e2e9ee"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    "data-name": "Path",
    d: "M49.239,0,65.5,16.11,16.261,42.9,0,26.787Z",
    transform: "translate(65.5 42.898)",
    fill: "rgba(127,151,167,0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-5",
    "data-name": "Path",
    d: "M16.261,0,0,16.11,49.239,42.9,65.5,26.787Z",
    transform: "translate(0 42.898)",
    fill: "rgba(127,151,167,0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-6",
    "data-name": "Path",
    d: "M49.239,42.9,65.5,26.788,16.261,0,0,16.111Z",
    transform: "translate(65.5)",
    fill: "rgba(127,151,167,0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-7",
    "data-name": "Path",
    d: "M16.261,42.9,0,26.788,49.239,0,65.5,16.111Z",
    fill: "rgba(127,151,167,0.5)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Stroke-5-2",
    "data-name": "Stroke-5",
    d: "M8,4A4,4,0,1,1,4,0,4,4,0,0,1,8,4Z",
    transform: "translate(37.611 98.556)",
    fill: "none",
    stroke: "#d2dde4",
    strokeWidth: 1,
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-52-2",
    "data-name": "Fill-52",
    d: "M8.573,9.97,5.3,8.293,2.068,10.032l.587-3.624L0,3.87l3.631-.563L5.226,0,6.883,3.277l3.641.493L7.917,6.358Z",
    transform: "translate(79 76)",
    fill: "#cce1ee",
    opacity: 0.5
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group-58-2",
    "data-name": "Group-58",
    transform: "translate(74 101)",
    opacity: 0.54
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-56_Clipped-3",
    "data-name": "Fill-56 Clipped"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-1-4",
    "data-name": "path-1",
    d: "M0,0V11.051H11.1V0H0Z",
    transform: "translate(0 0.01)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Fill-56_Clipped-4",
    "data-name": "Fill-56 Clipped",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-56-2",
    "data-name": "Fill-56",
    d: "M11.1,3.209l-1.156,6.83L3.083,11.051,0,4.848,4.953,0Z",
    transform: "translate(0 0.01)",
    fill: "#d2dde4"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group-41-Copy_Copy",
    "data-name": "Group-41-Copy Copy",
    transform: "translate(54 89)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-37-3",
    "data-name": "Fill-37",
    d: "M2.545,9.932A1.273,1.273,0,0,1,0,9.932V1.272a1.273,1.273,0,0,1,2.545,0Z",
    transform: "translate(4.411 0.013)",
    fill: "#d2dde4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-39-3",
    "data-name": "Fill-39",
    d: "M1.263,2.543A1.272,1.272,0,1,1,1.282,0L9.948.067a1.272,1.272,0,1,1-.02,2.543Z",
    transform: "translate(0.078 4.309)",
    fill: "#d2dde4"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyBox);
export default __webpack_public_path__ + "static/media/emptyBox.0abb28eebc5b5d37e6e1b51a87cdaec4.svg";
export { ForwardRef as ReactComponent };